import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { FC } from 'react';

const DownloadAndroidApkIcon: FC<SvgIconProps> = (props) => (
  <SvgIcon
    width="24px"
    height="24px"
    style={{ height: 130, width: 130, maxHeight: 90 }}
    viewBox="0 0 800 600"
    {...props}
  >
    <path
      id="Path"
      fill="inherit"
      d="M132,401.1c-1.6,0-3.1,0-4.7-0.1c-3.3,0-6.5-0.3-9.7-0.9c-3-0.5-5.9-1.5-8.6-2.9c-2.7-1.4-5.2-3.2-7.3-5.4
				c-2.2-2.2-4-4.7-5.3-7.4c-1.4-2.8-2.3-5.7-2.8-8.8c-0.5-3.3-0.8-6.6-0.9-10c0-1.1-0.1-4.8-0.1-4.8V238.2c0,0,0-3.7,0.1-4.7
				c0-3.3,0.3-6.7,0.9-9.9c0.5-3.1,1.4-6,2.8-8.8c2.8-5.5,7.2-10,12.6-12.8c2.7-1.4,5.6-2.4,8.6-2.9c3.2-0.5,6.5-0.8,9.8-0.9
				l4.7-0.1h535.5l4.8,0.1c3.2,0,6.5,0.3,9.7,0.9c3,0.5,6,1.5,8.7,2.9c5.4,2.8,9.8,7.3,12.6,12.8c1.4,2.8,2.3,5.7,2.8,8.8
				c0.5,3.3,0.8,6.7,0.9,10c0,1.5,0,3.1,0,4.7c0,2,0,3.9,0,5.8v111.1c0,1.9,0,3.8,0,5.7c0,1.7,0,3.3,0,4.9c-0.1,3.3-0.4,6.6-0.9,9.8
				c-0.5,3.1-1.4,6.1-2.8,8.9c-1.4,2.7-3.2,5.2-5.3,7.4c-2.1,2.2-4.6,4-7.3,5.4c-2.7,1.4-5.7,2.4-8.7,2.9c-3.2,0.5-6.5,0.8-9.7,0.9
				c-1.5,0-3.1,0.1-4.7,0.1l-5.7,0L132,401.1z"
    />
    <path
      style={{ fillRule: 'evenodd', clipRule: 'evenodd', fill: '#A4C639' }}
      id="Shape"
      fill="inherit"
      d="M214.1,261.4c0.2-0.3,0.4-0.5,0.7-0.8l9.5-9.5c3.1-3.1,8.2-3.1,11.4,0c3.1,3.1,3.1,8.2,0,11.3
				l-8.2,8.1c7.1,6.7,11.3,15,13,24.8c0.9,5.4-0.8,7.5-6.8,7.5l-87.2,0c-6.4,0.1-8.6-2.2-7.5-7.8c1.8-9,5.5-16.7,11.2-22.9l-9.3-9.2
				c-3.1-3.1-3.1-8.2,0-11.3c3.1-3.1,8.2-3.1,11.4,0l9.5,9.5c0.4,0.4,0.8,0.9,1.1,1.4c1.8-1,3.8-1.9,5.8-2.7
				C184.4,253.6,199.7,254.3,214.1,261.4z M170.2,284.8c0,2.2-1.8,4-4,4c-2.2,0-4-1.8-4-4c0-2.2,1.8-4,4-4
				C168.4,280.8,170.2,282.6,170.2,284.8z M213.2,288.8c2.2,0,4-1.8,4-4c0-2.2-1.8-4-4-4c-2.2,0-4,1.8-4,4
				C209.2,287,211,288.8,213.2,288.8z"
    />
    <path
      id="Shape_00000062156159513692599870000007454928920405724051_"
      fill="inherit"
      style={{ fill: '#A4C639' }}
      d="M144.7,347c2.1,0,3.2-1.1,4-3.8l1.3-3.9h11
				l1.2,3.9c0.8,2.7,2,3.8,4.1,3.8c2.3,0,3.8-1.3,3.8-3.4c0-0.8-0.2-1.8-0.6-3.1l-7.2-21.1c-1.3-3.9-3.1-5.4-6.6-5.4
				s-5.3,1.6-6.6,5.4l-7.3,21.1c-0.6,1.6-0.8,2.5-0.8,3.3C141,345.6,142.5,347,144.7,347z M151.6,333.5l3.7-12.4h0.4l3.7,12.4H151.6
				z"
    />
    <path
      id="Shape_00000119819762168567224120000007194588840098864538_"
      fill="inherit"
      style={{ fill: '#A4C639' }}
      d="M180.4,346.9c2.5,0,4-1.6,4-4.3v-6.4h5.3
				c7.5,0,12.1-4,12.1-11.1c0-6.7-4.5-11.1-11.7-11.1h-8.4c-3.8,0-5.2,1.5-5.2,5.4v23.2C176.5,345.4,177.9,346.9,180.4,346.9z
				 M184.4,330.4v-10.2h4.5c3.2,0,5,1.9,5,5.1c0,3.8-1.8,5.1-5.9,5.1H184.4z"
    />
    <path
      id="Path_00000104674802263785953230000010432242082412835517_"
      fill="inherit"
      style={{ fill: '#A4C639' }}
      d="M231,346.9c2.3,0,3.8-1.5,3.8-3.7
				c0-1.1-0.4-1.9-1.6-3.6l-8.2-11l7.7-8.3c1.1-1.1,1.4-1.9,1.4-2.9c0-1.9-1.5-3.5-3.5-3.5c-1.1,0-2,0.5-3.1,1.7l-11,11.9H216v-9.4
				c0-2.7-1.4-4.3-4-4.3c-2.5,0-4,1.5-4,4.3v24.6c0,2.7,1.5,4.3,4.1,4.3c2.5,0,3.9-1.5,3.9-4.3v-6.1l3-3.1l8,10.9
				C228.3,346.1,229.5,346.9,231,346.9z"
    />
    <path
      id="Shape_00000142864597391006816290000004069479167641885085_"
      fill="inherit"
      style={{ fill: '#FAFAFA' }}
      d="M264,245.2v29h10.5c4.7,0,8.3-1.3,10.7-3.9
				c2.3-2.5,3.5-6.1,3.5-10.6c0-4.6-1.1-8.1-3.4-10.6c-2.5-2.6-6-3.9-10.7-3.9H264z M268.5,249h5.4c3.7,0,6.4,0.9,8.1,2.6
				c1.6,1.7,2.5,4.4,2.5,8.1c0,3.7-0.9,6.3-2.5,8.1c-1.7,1.7-4.5,2.6-8.1,2.6h-5.3V249z M302.6,252.6c-3.2,0-5.8,1.1-7.7,3.2
				c-1.9,2.1-2.9,4.7-2.9,7.9c0,3.2,0.9,5.8,2.8,7.8c2,2.1,4.5,3.2,7.7,3.2s5.8-1.1,7.7-3.2c1.9-2,2.8-4.7,2.8-7.8
				c0-3.2-1-5.8-2.9-7.9C308.4,253.7,305.8,252.6,302.6,252.6z M302.6,256.2c2,0,3.6,0.8,4.7,2.4c1,1.3,1.5,3.1,1.5,5.2
				c0,2.1-0.5,3.8-1.5,5.2c-1.1,1.5-2.7,2.4-4.7,2.4s-3.6-0.8-4.7-2.4c-1-1.3-1.4-3-1.4-5.2c0-2.1,0.4-3.9,1.4-5.2
				C299.1,256.9,300.6,256.2,302.6,256.2z M315,253.2l7.2,21h4l4.4-15.7l4.4,15.7h4l7.2-21h-4.8l-4.5,15.9l-4.3-15.9h-4l-4.3,15.9
				l-4.5-15.9H315z M359.5,252.6c-1.3,0-2.5,0.2-3.6,0.8c-1.1,0.5-2,1.3-2.8,2.4v-2.6h-4.3v21h4.3v-12.6c0.2-1.7,0.8-3,1.8-4
				c0.9-0.9,2-1.3,3.2-1.3c3.3,0,4.9,1.8,4.9,5.4v12.6h4.3v-13C367.4,255.5,364.8,252.6,359.5,252.6z M372.9,244.6v29.6h4.3v-29.6
				H372.9z M392.3,252.6c-3.2,0-5.8,1.1-7.7,3.2c-1.9,2.1-2.9,4.7-2.9,7.9c0,3.2,0.9,5.8,2.8,7.8c2,2.1,4.5,3.2,7.7,3.2
				c3.2,0,5.8-1.1,7.7-3.2c1.9-2,2.8-4.7,2.8-7.8c0-3.2-1-5.8-2.9-7.9C398.1,253.7,395.5,252.6,392.3,252.6z M392.3,256.2
				c2,0,3.6,0.8,4.7,2.4c1,1.3,1.5,3.1,1.5,5.2c0,2.1-0.5,3.8-1.5,5.2c-1.1,1.5-2.7,2.4-4.7,2.4c-2,0-3.6-0.8-4.7-2.4
				c-1-1.3-1.4-3-1.4-5.2c0-2.1,0.4-3.9,1.4-5.2C388.8,256.9,390.3,256.2,392.3,256.2z M416.5,252.6c-2.6,0-4.7,0.4-6.3,1.4
				c-1.8,1.1-2.9,2.8-3.4,5l4.3,0.4c0.2-1.2,0.9-2,1.8-2.6c0.8-0.5,1.9-0.7,3.3-0.7c3.2,0,4.8,1.5,4.8,4.4v0.9l-4.7,0.1
				c-3.1,0.1-5.6,0.7-7.3,1.9c-1.9,1.3-2.8,3.1-2.8,5.4c0,1.7,0.7,3.2,2,4.3c1.2,1.1,2.9,1.7,5.1,1.7c1.9,0,3.5-0.4,4.9-1
				c1.2-0.6,2.2-1.5,3.1-2.5v3h4v-13.4c0-2.6-0.7-4.5-1.9-5.8C421.9,253.4,419.6,252.6,416.5,252.6z M421,264.5v1.2
				c0,1.6-0.7,3-2,4.1c-1.3,1.1-2.9,1.7-4.7,1.7c-1.1,0-2-0.3-2.7-0.8c-0.7-0.5-1-1.2-1-2c0-2.6,2-4,5.9-4.1L421,264.5z
				 M445.4,244.6v11.7c-1.7-2.5-3.9-3.7-6.5-3.7c-3,0-5.4,1.1-7.2,3.3c-1.6,2-2.4,4.6-2.4,7.7c0,3.2,0.8,5.8,2.5,7.9
				c1.8,2.2,4.2,3.3,7.3,3.3c2.9,0,5.1-1.1,6.5-3.1v2.5h4v-29.6H445.4z M440,256.1c1.6,0,2.9,0.6,4,1.9c1.1,1.4,1.6,3.2,1.6,5.5v0.4
				c0,2.1-0.4,3.8-1.3,5.2c-1.1,1.5-2.5,2.2-4.4,2.2c-2.1,0-3.7-0.8-4.7-2.3c-0.9-1.3-1.3-3.1-1.3-5.4s0.4-4.1,1.3-5.3
				C436.2,256.8,437.8,256.1,440,256.1z"
    />
    <path
      id="Shape_00000156589177487486049790000007684168799740552875_"
      fill="inherit"
      style={{ fill: '#FAFAFA' }}
      d="M273.4,330.8l2.5-7.9
				c1.8-5.5,3.4-10.6,5-16.4h0.3c1.7,5.7,3.2,10.9,5,16.4l2.5,7.9H273.4z M294.9,350.3h5.8L284.1,302h-6l-16.6,48.3h5.5l5-15.2h18.1
				L294.9,350.3z M307.3,350.3h5.4v-26.1c3.7-3.8,6.4-5.8,10.2-5.8c5,0,7.1,3,7.1,9.9v22h5.4v-22.6c0-9.1-3.5-13.9-11-13.9
				c-4.9,0-8.6,2.8-12.1,6.1h-0.2l-0.5-5.2h-4.4V350.3z M359.6,351.2c4.4,0,8.2-2.3,11.1-5.1h0.1l0.5,4.3h4.4v-52.5h-5.4v14l0.3,6.2
				c-3.3-2.6-6-4.2-10.3-4.2c-8.2,0-15.6,7.3-15.6,18.8C344.8,344.5,350.6,351.2,359.6,351.2z M360.7,346.7
				c-6.6,0-10.3-5.3-10.3-14.1c0-8.3,4.7-14.2,10.8-14.2c3.1,0,5.9,1.1,9.2,4v19.3C367.3,344.9,364.2,346.7,360.7,346.7z
				 M388.4,350.3h5.4v-23.2c2.5-6.2,6.2-8.4,9.2-8.4c1.4,0,2.2,0.2,3.4,0.6l1.1-4.7c-1.2-0.6-2.3-0.8-3.8-0.8c-4.1,0-7.7,3-10.2,7.5
				h-0.2l-0.5-6.5h-4.4V350.3z M426.5,351.2c8.8,0,16.5-6.9,16.5-18.6c0-11.9-7.8-18.8-16.5-18.8s-16.5,6.9-16.5,18.8
				C410,344.3,417.7,351.2,426.5,351.2z M426.5,346.7c-6.4,0-10.9-5.7-10.9-14.1c0-8.5,4.4-14.3,10.9-14.3s11,5.7,11,14.3
				C437.5,341,433,346.7,426.5,346.7z M452.8,350.3h5.4v-35.6h-5.4V350.3z M455.5,307.1c2.1,0,3.9-1.5,3.9-3.6
				c0-2.3-1.8-3.7-3.9-3.7c-2.3,0-3.9,1.4-3.9,3.7C451.6,305.5,453.2,307.1,455.5,307.1z M482.7,351.2c4.4,0,8.2-2.3,11.1-5.1h0.1
				l0.5,4.3h4.4v-52.5h-5.4v14l0.3,6.2c-3.3-2.6-6-4.2-10.3-4.2c-8.2,0-15.6,7.3-15.6,18.8C467.9,344.5,473.7,351.2,482.7,351.2z
				 M483.8,346.7c-6.6,0-10.3-5.3-10.3-14.1c0-8.3,4.7-14.2,10.8-14.2c3.1,0,5.9,1.1,9.2,4v19.3
				C490.3,344.9,487.3,346.7,483.8,346.7z M532.2,330.8l2.5-7.9c1.8-5.5,3.4-10.6,5-16.4h0.3c1.7,5.7,3.2,10.9,5,16.4l2.5,7.9H532.2
				z M553.7,350.3h5.8L542.9,302h-6l-16.6,48.3h5.5l5-15.2h18.1L553.7,350.3z M566.6,350.3h5.5v-19.5h8.2c10.7,0,17.8-4.8,17.8-14.8
				c0-10.4-7.1-14-18.1-14h-13.5V350.3z M572.1,326.3v-19.9h7.2c8.9,0,13.4,2.3,13.4,9.6c0,7.2-4.2,10.3-13.1,10.3H572.1z
				 M608.2,350.3h5.5v-15.6l8.7-10.2l14.9,25.7h6.2l-17.5-30l15.3-18.3h-6.3l-21,24.9h-0.1V302h-5.5V350.3z"
    />
  </SvgIcon>
);

export default DownloadAndroidApkIcon;
